import Moment from 'moment';

/**
 * Formats a date string to the standard preauth format: "MMM D, YYYY, h:mm A"
 * Example: "Aug 15, 2025, 10:12 AM"
 *
 * @param dateString - The date string to format (ISO format or any valid date string)
 * @param locale - Optional locale string (defaults to 'en' for English)
 * @param timeFormat - Optional time format string (defaults to 'h:mm A' with space before AM/PM)
 * @returns Formatted date string or 'N/A' if invalid
 */
export function formatCaptureDeadline(
  dateString: string,
  locale: string = 'en',
  timeFormat: string = 'h:mm A'
): string {
  if (!dateString) return 'N/A';

  try {
    const moment = Moment(dateString).locale(locale);
    const monthDay = moment.format('MMM D, YYYY');
    const time = moment.format(timeFormat);
    return `${monthDay}, ${time}`;
  } catch (error) {
    return 'N/A';
  }
}
